module.exports = __webpack_public_path__ + "static/frigg-bb8f8b45c64c2e2e49c184db2eab70e6.png";